/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/no-unknown-property */
/** @jsx jsx */
// eslint-disable-next-line no-unused-vars
import React from 'react'
import { css } from '@emotion/react'
import { graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import { jsx } from 'theme-ui'
import { Col, Flex, Heading, Text } from '../../components/elements'

export const RedRoof = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink"
    width="154px"
    height="35px"
  >
    <image
      x="0px"
      y="0px"
      width="154px"
      height="35px"
      href="data:img/png;base64,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"
    />
  </svg>
)

export const BottomSection = ({
  since,
  heading,
  main,
  qualifications,
  background,
  certifications,
  ...props
}) => {
  const data = useStaticQuery(graphql`
    query {
      mobileBG: imageSharp(original: { src: { regex: "/whyus-bottom/" } }) {
        gatsbyImageData
      }
    }
  `)

  return (
    <div
      css={css`
        display: grid;
      `}
      sx={{
        pt: [45, 45, 90, 120],
        minHeight: [400, 500, 700],
      }}
    >
      <GatsbyImage
        css={css`
          grid-area: 1/1;
          @media (min-width: 992px) {
            display: none;
          }
        `}
        {...props}
        image={data.mobileBG.gatsbyImageData}
      />
      <GatsbyImage
        css={css`
          grid-area: 1/1;
          display: none;
          @media (min-width: 992px) {
            display: block;
          }
        `}
        {...props}
        image={background.localFile.childImageSharp.gatsbyImageData}
      />
      <div
        css={css`
          grid-area: 1/1;
          position: relative;
        `}
      >
        <Flex position="relative" alignItems="flex-start" justifyContent="center">
          <Col maxWidth={[300, 400, 500]} mx="auto">
            <RedRoof color="primary" />
            <Heading color="primary" fontSize={3} fontWeight="bold" mt={-1} mb={0}>
              {since}
            </Heading>

            <Heading fontSize={[5, 5, 55]} fontWeight={900} mt={0}>
              {' '}
              {heading}{' '}
            </Heading>
            <Text fontSize={[2, 3]} sx={{ maxWidth: 625 }} mt={2} textAlign="center">
              {' '}
              {main}{' '}
            </Text>
          </Col>
        </Flex>
        <Flex
          width="100%"
          maxWidth={700}
          mx="auto"
          py={[3, 3, 4]}
          flexWrap="wrap"
          alignItems="stretch"
          justifyContent="center"
          sx={{
            position: 'relative',
            gap: '20px',
          }}
        >
          {certifications.map((certification, i) => {
            return (
              <p
                css={css`
                  background-color: white;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  z-index: 1;
                `}
                sx={{ width: ['45%', '45%', '33%'], zIndex: 1 }}
                py={2}
                px={3}
                mx={2}
                my={2}
                key={i}
              >
                <img
                  src={
                    certification.image.localFile.childImageSharp.gatsbyImageData.images.fallback
                      .src
                  }
                  alt=""
                  css={css`
                    height: 100%;
                    object-fit: contain;
                  `}
                />
              </p>
            )
          })}
        </Flex>
      </div>
    </div>
  )
}

export default BottomSection
